// ==================================================
//  Mobile
// ==================================================
function is_mobile() {
  const intFrameWidth = window.innerWidth;
  return (intFrameWidth <= 767) ? true : false;
}


// ==================================================
//  Setting
// ==================================================
const jsFixedHeader = 'js_fixedHeader';
// let scrollBreakPoint = $('.top_business').offset().top - 50;
let scrollBreakPoint = 0;
if (is_mobile()) {
  // SP
  scrollBreakPoint = 68;
}


$(document).ready(function() {
  // ==================================================
  //  Header
  // ==================================================
  const jsHeaderLogoSp = 'js_headerLogo_sp';
  const jsMenuButtonSp = 'js_menuButton_sp';
  const jsNavigationSp = 'js_navigation_sp';
  const jsDropdownSp = 'js_dropdown_sp';
  let jsHeaderLogoSrcSp = $('.' + jsHeaderLogoSp).find('img').attr('src');
  $('.' + jsDropdownSp).children('a').on('click', function(event) {
    if (is_mobile()) {
      event.preventDefault();
      $(this).parent().toggleClass(jsDropdownSp + '-active');
      $(this).next().slideToggle(200);
    }
  });
  $('.' + jsMenuButtonSp).on('click', function() {
    if (is_mobile()) {
      $(this).toggleClass(jsMenuButtonSp + '-active');
      $('.' + jsHeaderLogoSp).toggleClass(jsHeaderLogoSp + '-active');
      $('.' + jsNavigationSp).toggleClass(jsNavigationSp + '-active');
      if ($('.' + jsHeaderLogoSp).hasClass(jsHeaderLogoSp + '-active')) {
        jsHeaderLogoSrcSp = jsHeaderLogoSrcSp.replace('logo', 'logo-white');
      } else {
        jsHeaderLogoSrcSp = jsHeaderLogoSrcSp.replace('logo-white', 'logo');
      }
      $('.' + jsHeaderLogoSp).find('img').attr('src', jsHeaderLogoSrcSp);
    }
  });
  $(window).on('scroll', function() {
    // scrollBreakPoint = $('.top_business').offset().top - 50;
    scrollBreakPoint = 0;
    if (is_mobile()) {
      // SP
      scrollBreakPoint = 68;
    }
    if ($(this).scrollTop() <= scrollBreakPoint) {
      $('.' + jsFixedHeader).removeClass(jsFixedHeader + '-scroll');
    }
    if ($(this).scrollTop() > scrollBreakPoint) {
      $('.' + jsFixedHeader).addClass(jsFixedHeader + '-scroll');
    }
  });


  // ==================================================
  //  Pagetop
  // ==================================================
  $('a[href^="#"]').click(function() {
    const href= $(this).attr("href"), target = $(href == "#" || href == "" ? 'html' : href);
    $("html, body").animate({scrollTop: target.offset().top}, 360, "swing");
    return false;
  });


  // ==================================================
  // icosahedron
  // ==================================================
  const $d = polyhedron;
  const h = function() {
    $(this).toggleClass('hover');
  };
  const ldy = [-150, -90, -30];
  const ldx = -1;

  $d.init('mainvisual_canvas_frontLine');
  $d.addObjectDefinition(additionalObjects);
  $d.setDefaultAngle(-44, -92);
  $d.setColorNumber(1 - 0);
  $d.setLightDirection(ldy[1 - 0], ldx);
  $d.setTransparency((80 - 0) / 100);
  $d.setDrawMode(3 - 0);
  $d.setObject('icosa');
  $d.redraw(true);
});


$(window).on('load', function() {
  // ==================================================
  //  Header
  // ==================================================
  if ($(this).scrollTop() > scrollBreakPoint) {
    $('.' + jsFixedHeader).addClass(jsFixedHeader + '-scroll');
  }
});


// ==================================================
//  Scroll Animation
// ==================================================
const js_fadeInClass = 'js_fadeIn';
const js_fadeInActiveClass = 'js_fadeIn-active';
const callback = (entries) => {
  entries.forEach(
    (entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add(js_fadeInActiveClass);
      }
    }
  );
}
const options = {
  root: null,
  rootMargin: "65% 0px -35% 0px",
  threshold: 0
};
let observer = new IntersectionObserver(callback, options);
const animationItems = document.querySelectorAll('.' + js_fadeInClass);
animationItems.forEach(item => { observer.observe(item);});